import React from 'react';
import PropTypes from 'prop-types';
import Covid19Utils from '../../../common/Covid19Utils';
import FormRadioGroupContainer from '../../../redux/containers/FormRadioGroupContainer';
import FormDatepickerContainer from '../../../redux/containers/FormDatepickerContainer';
import './ConnectionDate.scss';

const isToday = (date) => {
  const now = new Date();
  return now.getDate() === date.getDate()
    && now.getMonth() === date.getMonth()
    && now.getFullYear() === date.getFullYear();
};

const ConnectionDate = (props) => {
  const {
    connectionDate,
    isSignUpJourney,
    isNoCovid19Confirmed,
    isDsl,
    hasInstalledOnt,
    lockDownEndDate,
    provider,
    isEssential,
    isCovid19Mode,
    delayedDaysForModemDelivery,
    isByoModemSelected
  } = props;
  const showPreferredDate = connectionDate === 'preferred';
  const minDate = Covid19Utils.getEarliestInstallDate(
    lockDownEndDate,
    isDsl,
    hasInstalledOnt,
    provider,
    isEssential,
    isNoCovid19Confirmed,
    isCovid19Mode,
    14,
    delayedDaysForModemDelivery,
    isByoModemSelected
  );
  const disableAsap = (isSignUpJourney && !isToday(minDate));
  return (
    <section>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-10">
                <FormRadioGroupContainer
                  name="connectionDate"
                  radioButtons={[{
                    id: 'asap',
                    label: 'ASAP',
                    autotestClass: 'autotest-asap',
                    disabled: disableAsap
                  }, {
                    id: 'preferred',
                    label: 'Set a preferred connection date',
                    autotestClass: 'autotest-preferred'
                  }]}
                />
                {showPreferredDate &&
                <div className="row">
                  <div className="col-xs-12 col-sm-7">
                    <FormDatepickerContainer
                      name="preferredDate"
                      label="Pick a connection date"
                      minDate={minDate}
                      required
                    />
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

ConnectionDate.propTypes = {
  connectionDate: PropTypes.string,
  isSignUpJourney: PropTypes.bool,
  isNoCovid19Confirmed: PropTypes.bool,
  isDsl: PropTypes.bool,
  hasInstalledOnt: PropTypes.bool,
  lockDownEndDate: PropTypes.instanceOf(Date),
  provider: PropTypes.string,
  isEssential: PropTypes.bool,
  isCovid19Mode: PropTypes.bool,
  delayedDaysForModemDelivery: PropTypes.number,
  isByoModemSelected: PropTypes.bool
};

export default ConnectionDate;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/ConnectionDate/ConnectionDate.js
 **/